module.exports = __webpack_public_path__ + "static/media/wedding.5a8f5727.jpg";